<template>
    <div class="chat-input text-center w-100">
        <div class="d-flex align-items-end p-2">
            <button class="mr-1 attach">
                <img :src="`${publicPath}/img/rcp/icon/attach.png`"/>
                <FileComponent @file-updated="captureFile($event)" :key="'file'"></FileComponent>
            </button>
            <textarea v-model="newMessage" ref="textarea" @input="autoResize" :placeholder="`${$t('Write text here')}...`"></textarea>
            <button @click="sendMessage" class="btn bg-upload-payment">
                <img :src="`${publicPath}/img/rcp/icon/cs-send.png`"/>
            </button>
        </div>
    </div>
</template>

<script>
import FileComponent from "@/components/FileComponent";

export default{
    data(){
        return{
            publicPath      :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            newMessage      :''
        }
    },
    components:{
        FileComponent
    },
    methods:{
        captureFile($event){
            this.$emit('capture-file',$event);
        },
        autoResize(){
            const ta = this.$refs.textarea;
            ta.style.height = 'auto';
            ta.style.height = Math.min(ta.scrollHeight, 120) + 'px';
        },
        sendMessage(){
            if(this.newMessage){
                this.$emit('send-message',this.newMessage);
                this.newMessage = "";
                this.$nextTick(() => {
                    const ta = this.$refs.textarea;
                    if(ta){ ta.style.height = '28px'; }
                });
            }
        }
    },
    mounted:function(){
        this.message = '';
    }
}
</script>

<style scoped src="@/assets/css/chat.css"></style>